import React from 'react';
import { BenefitType } from "../../enums/BenefitType";
import Start from "../../common/Start";
import VirtualSupplyLink from "../../structure/VirtualSupplyLink";
import { useFormikContext } from "formik";
import { FormValues } from "../../common/FormValues";

enum FormType { SERIOUS_HEALTH_CONDITION = 'GP62714', ACTIVE_DUTY_MILITARY_EVENTS = 'GP62715'}

const PhysicianStart = () => {
    const { values } = useFormikContext<FormValues>();

    return (
        <Start neededItems={[
            "The patient's job functions they are unable to perform",
            "The patient's diagnosis and associated dates",
            "If the claim is for the caretaker, we need basic information about that person"
        ]} detailsText={BenefitType.PAID_FAMILY_AND_MEDICAL_LEAVE === values.benefit
            ? <div>
                <div className="pds-u-padding-bottom-8">
                    <span>A paper version of this form is also available, which you can mail/email/fax to us:</span>
                </div>
                <div className="pds-u-padding-bottom-8">
                    <VirtualSupplyLink formNumber={FormType.SERIOUS_HEALTH_CONDITION}>
                        Leave for serious health condition / maternity
                    </VirtualSupplyLink>
                </div>
                <div>
                    <VirtualSupplyLink formNumber={FormType.ACTIVE_DUTY_MILITARY_EVENTS}>
                        Leave for active duty / military events
                    </VirtualSupplyLink>
                </div>
            </div>
            : undefined
        }/>
    )
};

export default PhysicianStart;